<script setup lang="ts">
import ErrorBoundary from '@/components/ErrorBoundary.vue';
</script>

<template>
  <ErrorBoundary>
    <router-view />
  </ErrorBoundary>
</template>
